import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=06dd8918&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dd8918')) {
      api.createRecord('06dd8918', component.options)
    } else {
      api.reload('06dd8918', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=06dd8918&", function () {
      api.rerender('06dd8918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ServerSideDatatable/Header.vue"
export default component.exports